// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nx-0";
export var buttonContainer = "_nx-3";
export var cancelButton = "_nx-4";
export var headerSection = "_nx-6";
export var headerTitle = "_nx-9";
export var messageSideLeft = "_nx-1";
export var messageSideRight = "_nx-2";
export var orderNumberContainer = "_nx-7";
export var orderNumberLabel = "_nx-8";
export var submitButton = "_nx-5";